import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Button } from '@dropbox/dig-components/buttons';
import { useTranslatedMessages } from 'hello-react/common/use-translated-messages';
import countries, { CountryCode } from 'common/constants/countries';
import { Menu } from '@dropbox/dig-components/menu';
import { GlobeLine } from '@dropbox/dig-icons/assets';
import { UIIcon } from '@dropbox/dig-icons';
import { useCountryCode } from 'signer-app/authentication/use-country-code';

const messages = defineMessages({
  chooseYourCountry: {
    id: '',
    description: 'Label for a dropdown',
    defaultMessage: 'Choose your country',
  },
});

type CountryProps = {
  className?: string;
};
export default function CountryDropdown({ className }: CountryProps) {
  const intl = useIntl();
  const { countryCode, setCountryCode } = useCountryCode();
  const translatedCountries = useTranslatedMessages(countries);
  const codes = Object.keys(countries) as CountryCode[];

  return (
    <Menu.Wrapper
      className={className}
      onSelection={setCountryCode}
      hasMaxHeight
    >
      {({ getTriggerProps, getContentProps }) => (
        <>
          <Button
            variant="transparent"
            data-testid="country-dropdown-btn"
            aria-label={intl.formatMessage(messages.chooseYourCountry)}
            size="small"
            withIconLeft={<UIIcon src={GlobeLine} />}
            withDropdownIcon
            hasNoUnderline
            {...getTriggerProps()}
          >
            {translatedCountries[countryCode] ?? translatedCountries.US}
          </Button>
          <Menu.Content {...getContentProps()} placement="top">
            {codes.map((code) => (
              <Menu.ActionItem
                data-testid={`country-dropdown-item-${code}`}
                key={code}
                value={code}
              >
                {translatedCountries[code]}
              </Menu.ActionItem>
            ))}
          </Menu.Content>
        </>
      )}
    </Menu.Wrapper>
  );
}
